/**
 * ComponenteRodape - Footer da Aplicação
 * 
 * CONTEXTO DE NEGÓCIO:
 * Componente de rodapé da plataforma jurídica.
 * Exibe informações de copyright, versão e links úteis.
 * 
 * FUNCIONALIDADES:
 * - Exibir informações de copyright
 * - Mostrar versão da aplicação
 * - Links para documentação e suporte (futuro)
 * 
 * RESPONSABILIDADES:
 * - Renderizar rodapé consistente em todas as páginas
 * - Fornecer informações básicas do sistema
 */

/**
 * Componente de rodapé da aplicação
 * 
 * IMPLEMENTAÇÃO:
 * - Componente funcional simples sem estado
 * - TailwindCSS para estilização
 * - Informações estáticas (ano, versão)
 */
export function ComponenteRodape(): JSX.Element {
  // Obter ano atual para copyright
  const anoAtual = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-gray-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          {/* Informações de Copyright */}
          <div className="text-center text-sm text-gray-600 md:text-left">
            <p>
              <span className="text-gray-500">Versão pré alpha 0.1.1</span>
            </p>
            <p className="mt-1 text-xs text-gray-500">
              Desenvolvido por{' '}
              <a
                href="https://vya.digital"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-primary-600"
              >
                vya.digital
              </a>
            </p>
          </div>

          {/* Links Úteis (futuro) */}
          <div className="flex items-center gap-6 text-sm text-gray-600">
            <a
              href="/docs"
              className="transition-colors duration-200 hover:text-primary-600"
            >
              Documentação
            </a>
            <a
              href="/suporte"
              className="transition-colors duration-200 hover:text-primary-600"
            >
              Suporte
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
